import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-owner-medical-consultation-other-income-table',
  templateUrl: './owner-medical-consultation-other-income-table.component.html',
  styleUrls: ['./owner-medical-consultation-other-income-table.component.css']
})
export class OwnerMedicalConsultationOtherIncomeTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
